// Lib
import { colors } from '@/lib/analytics/colors';
import { KPI_VALUE_CLASSIC } from '@/hooks/format/useFormatKpiValue';
import { SIZE_50 } from '@/lib/gridElements/size';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';

// Components
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const videoViews95PercentConfig: KpiType<typeof DefaultLoader> = {
    name: 'kpi.pinterest.video_views_95_percent',
    id: 'video_p95_views',
    icon: {
        name: 'impressions',
        style: colors.purple
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    type: 'kpi',
    loader: DefaultLoader
};
